<template>
    <div>
        <div class="card shadow p-0 m-0">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.groupes', 2) }}
                    </h3>
                </div>
            </div>

            <b-container class="p-2">
                <div class="card-title">
                    <router-link :to="{ name: 'create-groupe' }" v-if="can || hasAssistante">{{ $t('message.add') }}<i class="fas fa-plus-circle edit-icon"></i></router-link>
                </div>
                <b-row class="p-0 m-0">
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th class="w-50">Noms</th>
                                    <th class="w-25"> Effectifs</th>
                                    <th class="w-25">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(groupe, index) in groupes.data" :key="index+'test'">
                                    <td>{{ groupe.nom }}</td>
                                    <td>{{ groupe.users_count }}</td>
                                    <td>
                                        <a href="#" @click="showGroupe(groupe.uuid)" class=" btn btn-sm btn-primary"><span class="fa fa-eye"></span></a>
                                        <a href="#" @click="editGroupe(groupe.uuid)" class=" btn btn-sm btn-info"><span class="fa fa-edit"></span></a>
                                        <a href="#" @click="openModal(groupe.uuid)" class=" btn btn-sm btn-danger"><span class="fa fa-trash"></span></a>
                                    </td>
                                    <b-modal
                                        :id="'delete-modal'+ groupe.uuid"
                                        size="sm"
                                        header-bg-variant="danger"
                                        header-text-variant="light"
                                        title="Supprimer un groupe"
                                        hide-footer
                                    >
                                        <div class="d-block text-center">
                                        <h3>{{ groupe.nom }}</h3>
                                        </div>

                                        <div class="d-block float-right">
                                        <b-button variant="danger" @click="deleteGroupe(groupe.uuid)">
                                            {{ $t('message.delete') }}
                                        </b-button>

                                        <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                            {{ $t('message.cancel') }}
                                        </b-button>
                                        </div>
                                    </b-modal>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "Groupes",

        computed: {
            ...mapGetters(["subscribers",'hasAdminRole',
                'hasGestionnaireRole',
                'hasPraticienRole',
                'hasMedecinControleRole',
                'hasAssistante',
                'groupes'
            ]),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
            }
        },

        data() {
            return {
                mSubscribersFilter:[],
                searchTerm : ''
            }
        },
        methods: {
            getGroupes(page = 1, search = "", size = 10) {
                let args = {
                    page: page,
                    search: search,
                    size: size
                };

                this.$store.dispatch('getGroupes', { args : args });
            },
            showGroupe(uuid){
                // console.log("uuid ", uuid);
                this.$router.push({ name: 'show-groupe', params: { uuid: uuid } });
            },
            editGroupe(uuid) {
                // console.log("uuid ", uuid);
                this.$router.push({ name: 'edit-groupe', params: { uuid: uuid } });
            },
            openModal(uuid) {
                this.$bvModal.show("delete-modal"+uuid);
            },
            deleteGroupe(uuid) {
                let data = {
                    uuid
                }
                let successMessage = "Groupe supprimé avec succès";
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };
                this.$bvModal.hide("delete-modal" + uuid);
                this.$store.dispatch('deleteGroupe', { args: data, errorMessages, successMessage }).then(res => {
                    this.getGroupes();
                })
            }
        },

        mounted() {
            this.getGroupes();
        }
    }
</script>

<style scoped>

</style>